import { useMemo } from "react";
import { useAuth } from "@/auth/AuthProvider";
import { BaseListView } from "@/base";
import { notificationsListView } from "@/pages/notificationsListView";

// The broker's in-app inbox (BRK-S157 / PMS-S353), a BaseListView page since
// BRK-S252: the definition is `notificationsListView`. The bell's panel shows
// the latest 10 and links here for the rest.
export function NotificationsPage() {
  const { authedRequest } = useAuth();
  const def = useMemo(
    () => notificationsListView({ request: authedRequest }),
    [authedRequest],
  );
  return <BaseListView def={def} />;
}
